import { render, staticRenderFns } from "./desktopWaterPurifierMng.vue?vue&type=template&id=05dc5e5c&scoped=true"
import script from "./desktopWaterPurifierMng.vue?vue&type=script&lang=js"
export * from "./desktopWaterPurifierMng.vue?vue&type=script&lang=js"
import style0 from "./desktopWaterPurifierMng.vue?vue&type=style&index=0&id=05dc5e5c&prod&lang=css"
import style1 from "./desktopWaterPurifierMng.vue?vue&type=style&index=1&id=05dc5e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dc5e5c",
  null
  
)

export default component.exports